export const url = {
    home: () => "/",

    catalog: () => "/shop/catalog",

    category: (category) => `/shop/catalog/${category.slug}`,

    /// product: (product) => `/shop/products/${product.product_id || product.id}/${product.parent_id == null?-1:product.parent_id}`,
    product: (product) => `/shop/product/${product.url_key}`,
};

export function getCategoryParents(category) {
    return category.parent ? [...getCategoryParents(category.parent), category.parent] : [];
}
